<script>
import { mapActions } from "vuex";
import InfiniteAutocomplete from "./InfiniteAutocomplete.vue";

/**
 * 自社処分事業者・事業場選択コンポーネント
 *
 */
export default {
  name: "InfiniteTenantLocationAutoComplete",
  components: {
    InfiniteAutocomplete,
  },
  props: {
    locationId: {
      type: Number,
      default: null,
    },
    locationCode: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "排出事業場",
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    /**
     * カラム幅の指定
     */
    md: {
      type: [Number, String],
      default: 4,
    },
    classes: {
      type: String,
      default: null,
    },
    /**
     * 展開する種別
     * transport: 運搬業者
     * trader: 処分業者
     * either: 運搬・処分両方
     */
    searchType: {
      type: String,
      default: "transport",
      validator(val) {
        return ["transport", "trader", "either"].includes(val);
      },
    },
    withoutInvisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      searchKeyword: null,
      timerId: undefined,
      pageNumber: 0,
      locations: [],
      pagination: {
        next_page: null,
        prev_page: null,
        is_first_page: false,
        is_last_page: false,
      },
      workableId: null,
      workableCode: null,
    };
  },
  computed: {},
  watch: {
    /**
     * 事業場IDの変更検知
     * @param newValue
     * @param oldValue
     */
    locationId(newValue, oldValue) {
      this.workableId = newValue;
    },
    locationCode(newValue) {
      this.workableCode = newValue;
    },
    /**
     * 作業用排出事業者IDの変更検知
     */
    workableId() {
      this.returnCurrentValues();
    },
  },
  /**
   * 画面ロード時に呼ばれる.
   * ここで初期設定などを行う.
   */
  created() {
    if (this.locationId) {
      this.workableId = this.locationId;
      this.loadLocations(this.workableId);
    } else {
      this.fetchLocationMembers();
    }

    if (this.locationCode) {
      this.workableCode = this.locationCode;
    }

  },

  methods: {
    ...mapActions("DriverMasterSearchTenantTraderLocation", {
      fetchTraderLocations: "index",
    }),
    /**
     * 事業場チェンジ コールバック
     * ・事業者の再取得を行う
     */
    changeCallback(item) {
      this.workableCode = item.code;
    },
    /**
     * 事業場クリア コールバック
     */
    clearCallback() {
      this.workableCode = null;
      this.workableId = null;
      this.reloadLocations();
    },
    loadLocations(id) {
      const conditions = {
        search_type: this.searchType,
        target_id: id,
        enable_pagination: true,
        without_invisible: this.withoutInvisible,
        page: 1,
      };
      this.fetchTraderLocations({ conditions: conditions }).then((response) => {
        this.locations = response.trader_locations;
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      });
    },
    /**
     * 事業場 リロード処理
     */
    reloadLocations() {
      this.searchKeyword = null;
      this.pageNumber = 0;
      this.locations = [];
      Object.assign( this.$data.pagination, this.$options.data().pagination );
      this.fetchLocationMembers();
    },

    /**
     * 排出事業場オプション取得アクション
     */
    fetchLocationMembers() {
      this.loading = true;
      const conditions = {
        search_type: this.searchType,
        query: this.searchKeyword,
        without_invisible: this.withoutInvisible,
        enable_pagination: true,
        page: this.pageNumber,
      };

      this.fetchTraderLocations({ conditions: conditions }).then((response) => {
        this.locations = this.locations.concat(response.trader_locations);
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 排出事業場
     * 次ページ読込
     */
    insectCallback() {
      if (this.pageNumber > 0) {
        this.pageNumber++;
        this.fetchLocationMembers();
      }
    },
    enterKeydownCallback (value) {
      this.pageNumber = 0;
      this.searchKeyword = value;
      this.fetchLocationMembers();
    },
    returnCurrentValues () {
      this.$emit("update:values", this.workableId, this.workableCode);
    },
  },
};
</script>
<template>
  <div>
    <validation-provider
      v-slot="{ errors }"
      :value="workableId"
      :rules="{ required: required }"
      :class="{ requiredMark: required }"
      :name="label"
    >
      <InfiniteAutocomplete
        v-model="workableId"
        :classes="classes"
        :label="label"
        :disabled="disabled"
        :errorMessages="errors"
        :loading="loading"
        :members="locations"
        :pagination="pagination"
        :rounded="rounded"
        item-text="label"
        @change="changeCallback"
        @click:clear="clearCallback"
        @insect="insectCallback"
        @keydown:enter="enterKeydownCallback"
      >
        <template v-slot:prepend>
          <slot name="prepend" />
        </template>
        <template v-slot:prepend-inner>
          <slot name="prepend-inner" />
        </template>
        <template v-slot:selection="{ item }">
          <slot name="selection" v-bind:item="item">
            {{ item.text }}
          </slot>
        </template>
        <template v-slot:item="{ item }">
          <slot name="item" v-bind:item="item">
            {{ item.label }}
          </slot>
        </template>
        <template v-slot:append>
          <slot name="append" />
        </template>
        <template v-slot:append-outer>
          <slot name="append-outer" />
        </template>
      </InfiniteAutocomplete>
    </validation-provider>
  </div>
</template>
